import React from "react";
import styles from './ContainerHeader.module.sass';

const ContainerHeader = ({ children, title, ...props }: Props) => {
    return <div className={styles['container-header']} {...props}>
        <h3 className={styles['container-header__title']}>{ title }</h3>
        { children }
    </div>;
}

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    title: string
}

export default ContainerHeader;